import React, { memo, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ConsentDocumentStep from 'modules/views/shared/ConsentDocumentStep';

import { useWizardStepNavigation } from 'modules/views/shared/Wizard';
import { useAppDispatch, useAppSelector } from 'modules/state-mgmt/store';
import { selectConsentAgreement } from 'modules/state-mgmt/cache';
import { setConsentAcceptance } from 'modules/state-mgmt/onboarding';
import { ConsentAgreementType } from 'constants/common';

const StandardBiometricConsent = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { goToNextStep, goToPreviousStep } = useWizardStepNavigation();
  const [isChecked, setIsChecked] = useState(false);

  const agreement = useAppSelector(state => selectConsentAgreement(state, ConsentAgreementType.BiometricConsent));
  const acceptedIds = useAppSelector(state => state.onboarding.temp?.consentAcceptances || []);

  // Initialise the checkbox from previously recorded acceptances (e.g. on back-navigation)
  useEffect(() => {
    if (agreement?.consentAgreementContentId && acceptedIds.includes(agreement.consentAgreementContentId)) {
      setIsChecked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agreement?.consentAgreementContentId]);

  const onNext = () => {
    if (agreement?.consentAgreementContentId) {
      dispatch(setConsentAcceptance({ id: agreement.consentAgreementContentId, accepted: isChecked }));
    }
    goToNextStep();
  };

  const fields = useMemo(
    () =>
      agreement
        ? [
            {
              name: agreement.name,
              id: agreement.consentAgreementContentId,
              isRequired: true,
            },
          ]
        : [],
    [agreement],
  );

  return (
    <ConsentDocumentStep
      htmlContent={agreement?.htmlContent}
      checkboxLabel={t('registrationConsent.biometricCheckbox')}
      isChecked={isChecked}
      fields={fields}
      onCheckChange={setIsChecked}
      onBack={() => goToPreviousStep()}
      onNext={onNext}
    />
  );
};

export default memo(StandardBiometricConsent);
